import { Controller } from "@hotwired/stimulus"
import { createConsumer } from "@rails/actioncable"

export default class extends Controller {
  connect() {
    this.lastPresenceActivityAt = null
    this.presenceStarted = false
    this.presenceHeartbeat = null
    this.presenceSubscription = null
    this.consumer = null

    this.boundRecordActivity = this.recordActivity.bind(this)
    document.addEventListener('chat:activity', this.boundRecordActivity)

    this.startPresence()
  }

  disconnect() {
    document.removeEventListener('chat:activity', this.boundRecordActivity)
    this.stopPresence()
  }

  recordActivity() {
    const now = Date.now()
    if (this.lastPresenceActivityAt && (now - this.lastPresenceActivityAt) < 30000) return
    this.lastPresenceActivityAt = now
    this.sendPresence("activity")
  }

  startPresence() {
    if (this.presenceStarted) return

    if (!this.consumer) {
      this.consumer = createConsumer()
    }

    this.presenceStarted = true
    this.presenceSubscription = this.consumer.subscriptions.create({ channel: "ChatPresenceChannel", role: "admin" }, {
      received: (data) => {
        this.handlePresenceMessage(data)
      }
    })

    this.sendPresence("activity")
    this.sendPresence("heartbeat")
    this.presenceHeartbeat = setInterval(() => this.sendPresence("heartbeat"), 60000)
  }

  stopPresence() {
    if (this.presenceHeartbeat) {
      clearInterval(this.presenceHeartbeat)
      this.presenceHeartbeat = null
    }

    if (this.presenceSubscription) {
      try { this.presenceSubscription.unsubscribe() } catch (_) {}
      this.presenceSubscription = null
    }

    this.presenceStarted = false
  }

  sendPresence(action) {
    if (!this.presenceSubscription) return
    this.presenceSubscription.perform(action, { actor_type: "admin" })
  }

  handlePresenceMessage(data) {
    if (!data || data.scope !== "partner") return

    const partnerType = data.partner_type
    const partnerId = String(data.partner_id)
    const label = this.presenceLabel(data.state, data.away_for_seconds)
    const dotClass = this.presenceDotClass(data.state)

    const elements = document.querySelectorAll(
      `[data-presence-partner-type="${partnerType}"][data-presence-partner-id="${partnerId}"]`
    )

    elements.forEach((el) => {
      const role = el.dataset.presenceRole
      if (role === "dot") {
        el.classList.remove("bg-emerald-400", "bg-amber-400", "bg-slate-500")
        el.classList.add(dotClass)
        el.setAttribute("title", label)
        el.setAttribute("aria-label", label)
      } else if (role === "text") {
        el.textContent = label
      }
    })
  }

  presenceLabel(state, awayForSeconds) {
    if (state === "online") return "Online"
    if (state === "offline") return "Offline"

    const seconds = Number(awayForSeconds || 0)
    if (seconds <= 0) return "Away"

    const minutes = Math.max(1, Math.floor(seconds / 60))
    return `Away ${minutes}m`
  }

  presenceDotClass(state) {
    if (state === "online") return "bg-emerald-400"
    if (state === "away") return "bg-amber-400"
    return "bg-slate-500"
  }
}
